var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionSubscriptionOsmandLive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 11.5C22 16.2778 18.8098 20.308 14.4448 21.5812L12.5604 23.5475C12.2834 23.8366 11.9004 24 11.5 24C11.0996 24 10.7166 23.8366 10.4396 23.5475L8.55524 21.5812C4.19023 20.308 1 16.2778 1 11.5C1 5.70101 5.70101 1 11.5 1C17.299 1 22 5.70101 22 11.5ZM16 11.5C16 13.9853 13.9853 16 11.5 16C9.01472 16 7 13.9853 7 11.5C7 9.01472 9.01472 7 11.5 7C13.9853 7 16 9.01472 16 11.5Z",
    fill: "#B24100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 11.5C21 15.913 17.9911 19.6231 13.9129 20.6909L11.8384 22.8556C11.75 22.9478 11.6278 23 11.5 23C11.3722 23 11.25 22.9478 11.1616 22.8556L9.08708 20.6909C5.00892 19.6231 2 15.913 2 11.5C2 6.25329 6.25329 2 11.5 2C16.7467 2 21 6.25329 21 11.5ZM11.5 17C14.5376 17 17 14.5376 17 11.5C17 8.46243 14.5376 6 11.5 6C8.46243 6 6 8.46243 6 11.5C6 14.5376 8.46243 17 11.5 17Z",
    fill: "#FFA600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 13C4.79086 13 3 14.7909 3 17C3 19.2091 4.79086 21 7 21H17C19.2091 21 21 19.2091 21 17C21 14.7909 19.2091 13 17 13H7Z",
    fill: "#206FE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 14H7C5.34315 14 4 15.3431 4 17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17C20 15.3431 18.6569 14 17 14Z",
    fill: "#0C90F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 15H5.5V19H8.5V18H6.5V15Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15H9V19H10V15Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15H11.5L12.5 17.6667L13.5 15H14.5L13 19H12L10.5 15Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15H18V16H16V16.5H18V17.5H16V18H18V19H15V15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionSubscriptionOsmandLive);
export default __webpack_public_path__ + "static/media/ic_action_subscription_osmand_live.566aca85b0257062df5b191f1c3b9f65.svg";
export { ForwardRef as ReactComponent };